import { render } from "./HeroiconsSolidCake.vue?vue&type=template&id=1f7b98c3"
const script = {}

import exportComponent from "/Users/administrator/Sites/HengFuTong/extends/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidCake.vue"]])

export default __exports__